import React from 'react';
import { Route } from 'react-router-dom';

type AppRouteType = {
  component: any,
  layout?: any,
  path?: string;
  exact?: boolean;
}

export const AppRoute = (props: AppRouteType) => {
  const { component: Component, layout: Layout, ...rest } = props;

  return (
    <Route
      {...rest}
      render={props => (
        Layout ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Component {...props} />
        )
      )}
    />
  )
}